export const validateAnBik = (account: string, bik: string) => {
  if (!account || !bik) {
    return false
  }

  const bikRs = bik.toString().slice(-3) + account

  let checksum = 0
  const coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]

  coefficients.forEach((item, i) => {
    checksum += coefficients[i] * (parseInt(bikRs[i]) % 10)
  })

  return checksum % 10 === 0
}
